/* global $ */
/* global URLS */
/* global gettext */

(function (scope) {
  "use strict";

  var PrintToolbar2DView = (scope.PrintToolbar2DView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;
    this.$el = $("#PrintToolbarView");
    this.fullscreen = false;
    this.viewerHelpDisplayed = false;

    this.$el.on("click", "#print-favorite", this.favorite.bind(this));
    this.$el.on("click", "#print-share", this.share.bind(this));
    this.$el.on("click", "#print-help", this.toggleViewerHelp.bind(this));
    this.$el.on(
      "click",
      ".viewer-help-close",
      this.toggleViewerHelp.bind(this)
    );

    this.$el.on("click", ".reset-position-viewer", this.toggleReset.bind(this));
    this.$el.on("click", "#print-zoom-in", this.toggleZoomIn.bind(this));
    this.$el.on("click", "#print-zoom-out", this.toggleZoomOut.bind(this));

    this.checkFavorite();
  });

  /**
   * toggle show/hide viewer help
   * @private
   */
  PrintToolbar2DView.prototype.toggleViewerHelp = function () {
    if (this.viewerHelpDisplayed) {
      $(".viewer-help", this.$el).hide();
      this.viewerHelpDisplayed = false;
    } else {
      $(".viewer-help", this.$el).show();
      this.viewerHelpDisplayed = true;
    }
  };

  /**
   * display the right help based on of the current mode
   * @public
   */
  PrintToolbar2DView.prototype.toggleMode = function (tool) {
    $(".viewer-help-icons-review").hide();
    $(".viewer-help-icons-configuration").hide();

    switch (tool) {
      case sculpteo.PrintToolsView.TOOLS.CONFIGURATION:
        $(".viewer-help-icons-configuration").show();
        break;
      case sculpteo.PrintToolsView.TOOLS.REVIEW:
        $(".viewer-help-icons-review").show();
        break;
    }
  };

  /**
   * toggle reset the model position
   * @private
   */
  PrintToolbar2DView.prototype.toggleReset = function () {
    this.controller.toggleResetModelPosition();
  };

  /**
   * toggle zoom in
   * @private
   */
  PrintToolbar2DView.prototype.toggleZoomIn = function () {
    this.controller.toggleZoomIn();
  };

  /**
   * toggle zoom out
   * @private
   */
  PrintToolbar2DView.prototype.toggleZoomOut = function () {
    this.controller.toggleZoomOut();
  };

  /**
   * Show the help tool
   * @public
   */
  PrintToolbar2DView.prototype.showHelpTool = function () {
    $(".show-help-modal-tool", this.$el).show();
  };

  /**
   * Show the help tool
   * @public
   */
  PrintToolbar2DView.prototype.hideHelpTool = function () {
    $(".show-help-modal-tool", this.$el).hide();
  };

  /**
   * Handles favotite button
   * @private
   */
  PrintToolbar2DView.prototype.favorite = function (e) {
    e.preventDefault();

    $.post(URLS.favorite + this.design.design_uuid).done(
      function (json) {
        this.notify(json.message);
        this.updateFavoriteIcon(json);
      }.bind(this)
    );
  };

  /**
   * Handles share button. Copy current location to clipboard
   * @private
   */
  PrintToolbar2DView.prototype.share = function (e) {
    var input = $("<input>")
      .attr("type", "text")
      .attr("id", "clipboard")
      .css({ position: "absolute", top: "-1000px", left: "-1000px" })
      .val(document.location.origin + document.location.pathname)
      .insertAfter(this.$el);

    document.querySelector("#clipboard").select();
    document.execCommand("copy");

    this.notify(gettext("Copied to clipboard"));
    input.remove();
  };

  /**
   * Displays a temporary notification in the toolbar
   * @public
   * @param {string} text
   */
  //todo need to be fixed
  PrintToolbar2DView.prototype.notify = function (text) {
    var $message = $("<span>").addClass("notification").text(text);
    $(".toolbar-notification", this.$el).html($message);
    setTimeout(function () {
      $message.remove();
    }, 2000);
  };

  /**
   * Ask server if the design is in user's favorites
   * @private
   */
  PrintToolbar2DView.prototype.checkFavorite = function () {
    $.getJSON(
      URLS.favorite + this.design.design_uuid,
      this.updateFavoriteIcon.bind(this)
    );
  };

  /**
   * Update favorite icon based on design's status
   * @private
   * @param {object} json - server's response
   */
  PrintToolbar2DView.prototype.updateFavoriteIcon = function (json) {
    $("#print-favorite span", this.$el).toggleClass(
      "icon-star",
      json.is_favorite
    );
    $("#print-favorite span", this.$el).toggleClass(
      "icon-star_border",
      !json.is_favorite
    );
  };
})((window.sculpteo = window.sculpteo || {}));
